import { put, call } from 'redux-saga/effects';
import { reportsActions } from '../redux/reportsSlice';
import {
    fetchRecruitmentFunnel,
    fetchTimeToHireData,
    fetchSourceOfHireStats,
    fetchSourceOfHireChart,
} from '../../apis/reports';
import { fetchJobsList } from '../../apis/job';
import { fetchCompanyBaseUsers } from '../../apis/user';
import {
    formatFunnelResponse,
    formatTimeToHireResponse,
    formatSourceOfHireStatsResponse,
    formatSourceOfHireChartResponse,
    formatJobsOptions,
    formatRecruitersOptions,
} from './manager';
import {
    IFetchFunnelAction,
    IFetchTimeToHireAction,
    IFetchSourceOfHireAction,
} from '../redux/interface';
import { PayloadAction } from '@reduxjs/toolkit';
import { IJobLabelOption, IRecruiterOption } from '../../../common';

export function* fetchFunnelSaga(
    action: PayloadAction<IFetchFunnelAction>
) {
    try {
        const { response } = yield call(
            fetchRecruitmentFunnel,
            action.payload
        );
        if (response?.status === 200) {
            yield put(
                reportsActions.setFunnel({
                    funnelData: formatFunnelResponse(response.data),
                })
            );
        }
    } catch (error) {
        console.error('fetchFunnelSaga error:', error);
    } finally {
        yield put(reportsActions.fetchFunnelDone());
    }
}

export function* fetchTimeToHireSaga(
    action: PayloadAction<IFetchTimeToHireAction>
) {
    try {
        const { response } = yield call(
            fetchTimeToHireData,
            action.payload
        );
        if (response?.status === 200) {
            yield put(
                reportsActions.setTimeToHire({
                    timeToHireData: formatTimeToHireResponse(response.data),
                })
            );
        }
    } catch (error) {
        console.error('fetchTimeToHireSaga error:', error);
    } finally {
        yield put(reportsActions.fetchTimeToHireDone());
    }
}

export function* fetchSourceOfHireStatsSaga(
    action: PayloadAction<IFetchSourceOfHireAction>
) {
    try {
        const { response } = yield call(
            fetchSourceOfHireStats,
            action.payload
        );
        if (response?.status === 200) {
            yield put(
                reportsActions.setSourceOfHireStats({
                    stats: formatSourceOfHireStatsResponse(response.data),
                })
            );
        }
    } catch (error) {
        console.error('fetchSourceOfHireStatsSaga error:', error);
    } finally {
        yield put(reportsActions.fetchSourceOfHireStatsDone());
    }
}

export function* fetchSourceOfHireChartSaga(
    action: PayloadAction<IFetchSourceOfHireAction>
) {
    try {
        const { response } = yield call(fetchSourceOfHireChart, action.payload);
        if (response?.status === 200) {
            yield put(
                reportsActions.setSourceOfHireChart({
                    chart: formatSourceOfHireChartResponse(response.data),
                })
            );
        }
    } catch (error) {
        console.error('fetchSourceOfHireChartSaga error:', error);
    } finally {
        yield put(reportsActions.fetchSourceOfHireChartDone());
    }
}

export function* fetchReportFilterOptionsSaga() {
    try {
        const [jobsResult, usersResult]: [
            { response?: { status: number; data: IJobLabelOption[] }; error?: unknown },
            { response?: { status: number; data: IRecruiterOption[] }; error?: unknown },
        ] = yield call(() =>
            Promise.all([fetchJobsList(), fetchCompanyBaseUsers()])
        );

        const jobsOptions =
            jobsResult.response?.status === 200
                ? formatJobsOptions(jobsResult.response.data)
                : [];

        const recruitersOptions =
            usersResult.response?.status === 200
                ? formatRecruitersOptions(usersResult.response.data)
                : [];

        yield put(
            reportsActions.setReportFilterOptions({
                jobsOptions,
                recruitersOptions,
            })
        );
    } catch (error) {
        console.error('fetchReportFilterOptionsSaga error:', error);
    } finally {
        yield put(reportsActions.fetchReportFilterOptionsDone());
    }
}
